import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '@env/environment';
import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared';
import { HomeModule } from './home/home.module';
import { AboutModule } from './about/about.module';
import {AppComponent} from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {AuthServiceConfig, FacebookLoginProvider, GoogleLoginProvider, SocialLoginModule} from 'angularx-social-login';
import {ShoppingModule} from '@app/shopping/shopping.module';
import {ShoppingPromotionModule} from '@app/shopping-promotion/shopping-promotion.module';
import {AngularFireModule} from 'angularfire2';
import {AngularFireDatabaseModule} from 'angularfire2/database';
import {AngularFirestoreModule} from 'angularfire2/firestore';
import {LoginModule} from '@app/login-page/login-page.module';
import {LoginComponentModule} from '@app/login/login.module';
import {LoginModalComponent} from '@app/login-modal.component';
import {AccreditedModule} from '@app/accredited/accredited.module';
import {DomainService} from '@app/core/domain/domain.service';
import {SorteioNfModule} from '@app/sorteio-nf/sorteio.nf.module';
import {NgxPrintModule} from 'ngx-print';

const config = new AuthServiceConfig([

  {
    id: FacebookLoginProvider.PROVIDER_ID,
    provider: new FacebookLoginProvider('753549924795365')
  } ,
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider('397000068923-pojrmc7i5ibaarmnl5rskh1g7kbjqbtv.apps.googleusercontent.com')
  }
]);

export function provideConfig() {
  return config;
}

@NgModule({
  imports: [
    BrowserModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireDatabaseModule,
    ServiceWorkerModule.register('/ngsw-worker.js', {enabled: environment.production}),
    FormsModule,
    HttpModule,
    TranslateModule.forRoot(),
    NgbModule.forRoot(),
    CoreModule,
    SharedModule,
    HomeModule,
    SorteioNfModule,
    ShoppingModule,
    ShoppingPromotionModule,
    AboutModule,
    LoginModule,
    AccreditedModule,
    LoginComponentModule,
    AppRoutingModule,
    SocialLoginModule,
    NgxPrintModule
  ],
  declarations: [AppComponent, LoginModalComponent],
  entryComponents: [
    LoginModalComponent
  ],
  providers: [
    {
      provide: AuthServiceConfig,
      useFactory: provideConfig
    },
    DomainService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/app.module.ts